<script>
    import {createEventDispatcher} from "svelte";
    import Button from "./Button.svelte";
    const dispatch = createEventDispatcher();

    export let name = '';
    export let disabled = false;
</script>

<!--------------------------------------------------------------------------------------------------------------------->

<form on:submit|preventDefault>
    <h3>{name && name}</h3>
    <slot /> <!-- inputs -->

    <section class="buttons-wrapper">
        <div class="btns-left"><slot name="btns-left"/></div>

        <div class="btns-right"><slot name="btns"> <!-- buttons -->
            <Button clazz="clear" on:click={() => {dispatch('clear')}}>clear</Button>
            <Button type="submit" clazz="submit" {disabled} on:click>submit</Button>
        </slot></div>
    </section>
</form>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    form {
        box-shadow: 2px 2px 8px;
        border-radius: 8px;
        width: 100%;
        margin: .7rem auto 2rem;
        padding: 1rem 2rem;
    }

    .buttons-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 1.5rem;
    }
    .btns-left {
        flex-grow: 1;
        display: flex;
        justify-content: flex-start;
    }
    .btns-right {
        flex-grow: 2;
        display: flex;
        justify-content: flex-end;
    }

    h3 {
        text-align: center;
        margin-bottom: .5rem;
    }
</style>